import React, { memo } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import AssociateCAPActionPlans from './AssociateCAPActionPlans';
import AssociateCAPHistorical from './AssociateCAPHistorical';
import '../associateCAPTabs.scss';

interface Props {
    empNo: string;
    setShowAcknowledge: React.Dispatch<React.SetStateAction<boolean>>;
    setActionPlanId: React.Dispatch<React.SetStateAction<number>>;
    setSessionId: React.Dispatch<React.SetStateAction<number>>;
    via?: string;
    setVia: React.Dispatch<React.SetStateAction<string>>;
}

const AssociateCAPTabs: React.FC<Props> = memo(({ empNo, setShowAcknowledge, setActionPlanId, setSessionId, via, setVia }) => {
    const activeTabIndex = via === 'historical' ? 1 : 0;
    return (
        <div className="cap-tabs">
            <TabView activeIndex={activeTabIndex}>
                <TabPanel header="Active Action Plans">
                    <div className="cap-tabs__scroll-body">
                        <AssociateCAPActionPlans empNo={empNo} setShowAcknowledge={setShowAcknowledge} setActionPlanId={setActionPlanId} setSessionId={setSessionId} setVia={setVia} />
                    </div>
                </TabPanel>
                <TabPanel header="Historical">
                    <div className="cap-tabs__scroll-body">
                        <AssociateCAPHistorical empNo={empNo} setShowAcknowledge={setShowAcknowledge} setActionPlanId={setActionPlanId} setSessionId={setSessionId} setVia={setVia} />
                    </div>                    
                </TabPanel>
            </TabView>
        </div>
    );
});

AssociateCAPTabs.displayName = 'AssociateCAPTabs';
export default AssociateCAPTabs;
